import { render } from "./TeacherExamRecordManageView.vue?vue&type=template&id=90d903fc&scoped=true"
import script from "./TeacherExamRecordManageView.vue?vue&type=script&lang=js"
export * from "./TeacherExamRecordManageView.vue?vue&type=script&lang=js"

import "./TeacherExamRecordManageView.vue?vue&type=style&index=0&id=90d903fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90d903fc"]])

export default __exports__